<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
    <div [innerHtml]="message"></div>
    <small [innerHtml]="info"></small>
    @if (data.details?.length) {
        <ul>
            @for (detail of data.details; track $index) {
                <li>{{ detail }}</li>
            }
        </ul>
    }
</div>
<div mat-dialog-actions align="end">
    @if (cancelButtonText) {
        <button (click)="onDismiss()" mat-button>{{ cancelButtonText }}</button>
    }
    <button mat-raised-button color="primary" (click)="onConfirm()">
        {{ confirmButtonText ?? "OK" }}
    </button>
</div>
